export const TRANSLATIONS_JP_DOCUMENTS_AND_DRIVE = {
  "upload.title": "ドキュメントをアップロード",
  "upload.drag": "ここにファイルをドラッグ＆ドロップ",
  "upload.select": "ファイルを選択",
  "upload.formats": "対応フォーマット: PDF, DOCX, XLSX, TXT, JSON, CSV, MD",
  "upload.processing": "処理中...",
  "upload.success": "ドキュメントが正常に処理されました",
  "upload.error": "ドキュメントの処理中にエラーが発生しました",
  "upload.process_immediately": "すぐに処理",
  "upload.folder_name": "フォルダ名",
  "upload.folder_placeholder": "フォルダ名",
  "upload.tags": "タグ",
  "upload.add_tag": "タグ（カンマ区切り）",
  "upload.files_to_upload": "アップロードするファイル",
  "upload.upload_all": "すべてアップロード",
  "upload.role_id": "アクセスロール",
  "upload.role_id_help": "任意：このドキュメントを閲覧できるロールを制限します。",
  "upload.role_id_required": "ロールを選択してください。",
  "upload.select_role": "ロールを選択",
  "upload.loading_roles": "ロールを読み込み中…",
  "upload.queued.title": "ファイルがキューに追加されました",
  "upload.queued.message": "ファイルは処理のためにキューに追加されました。",
  "upload.queued.taskId": "タスクID",
  "upload.queued.checkTasks": "タスクセクションでステータスを確認できます。",
  "upload.duplicated.title": "重複ファイル",
  "upload.duplicated.message":
    "'{{name}}'という名前のドキュメントが既に存在します。置き換えますか？",
  "upload.duplicated.replace": "置き換え",
  "upload.success.title": "アップロード成功！",
  "upload.success.message":
    "ドキュメント '{{name}}' は '{{folder}}' フォルダに正常にアップロードされました。",
  "documents.loading": "ドキュメントを読み込み中...",
  "documents.name": "名前",
  "documents.source": "ソース",
  "documents.vectors": "使用ベクトル",
  "documents.date": "日付",
  "documents.delete_document_tooltip": "ドキュメントを削除",
  "documents.delete_confirm.title": "ドキュメントを削除",
  "documents.delete_confirm.body": "この操作は取り消せません。",
  "documents.delete_confirm.confirm": "削除",
  "documents.delete_confirm.error": "ドキュメントを削除できませんでした。",
  "documents.download_document_tooltip": "ドキュメントをダウンロード",
  "documents.context.ask_only_this": "このドキュメントについてのみ質問する",
  "documents.context.confirm_only_this": "チャットをこのドキュメントに限定しますか？",
  "documents.no_documents":
    "インデックスされたドキュメントはありません。'ドキュメントをアップロード'セクションでアップロードしてください。",
  "documents.refresh": "更新",
  "documents.indexed_documents":
    "現在システムにインデックスされているドキュメントのリスト。",
  "documents.indexed_documents_title": "インデックス済みドキュメント",
  "documents.tab_overview": "概要",
  "documents.tab_network": "セマンティック",
  "documents.tab_details": "詳細",
  "documents.tab_viewer": "ビューアー",
  "documents.sidebar_types": "種類",
  "documents.types_distribution": "種類ごとの分布",
  "documents.type_.pdf": "PDF",
  "documents.type_.docx": "DOCX",
  "documents.type_.txt": "TXT",
  "documents.type_.csv": "CSV",
  "documents.type_.xlsx": "XLSX",
  "documents.type_.pptx": "PPTX",
  "documents.type_.email": "メール",
  "documents.type_.other": "その他",
  "documents.type_.md": "MD",
  "documents.group_today": "今日",
  "documents.group_last3days": "直近3日間",
  "documents.group_lastweek": "先週",
  "documents.group_lastmonth": "先月",
  "documents.group_older": "それ以前",
  "documents.domains": "ドメイン",
  "documents.other_domains": "その他のドメイン",
  "documents.documents_word": "件",
  "documents.search_domain": "ドメインを検索...",
  "documents.no_domain_results": "結果なし",
  "documents.subdomains": "サブドメイン",
  "documents.clear_filter": "フィルターをクリア",
  "documents.back": "戻る",
  "documents.domain_distribution": "ドメインごとの分布",
  "documents.subdomain_distribution": "{{domain}}のサブドメインごとの分布",
  "documents.select_domain_hint":
    "ドメインを選択してサブドメインとドキュメントを表示します。",
  "documents.select_subdomain_hint":
    "サブドメインを選択してドキュメントを表示します。",
  "documents.redirecting_to_details": "ドキュメント詳細にリダイレクト中...",
  "documents.details_for_type": "種類: {{type}} のドキュメント",
  "documents.details_for_domain": "ドメイン: {{domain}} のドキュメント",
  "documents.details_all": "すべてのドキュメント",
  "documents.group_type": "種類",
  "documents.group_domain": "ドメイン",
  "documents.no_documents_in_group": "このグループにドキュメントはありません。",
  "documents.no_documents_found": "ドキュメントが見つかりません。",
  "drive.viewer_aria_label": "マイドライブ ビューア（読み取り専用）",
  "drive.search_placeholder": "マイドライブを検索",
  "drive.my_drive": "マイドライブ",
  "drive.filter.type.aria": "種類でフィルター",
  "drive.filter.type.label_all": "種類: すべて",
  "drive.type.folder": "フォルダ",
  "drive.type.doc": "ドキュメント",
  "drive.type.sheet": "スプレッドシート",
  "drive.type.slide": "プレゼンテーション",
  "drive.type.pdf": "PDF",
  "drive.type.image": "画像",
  "drive.type.video": "動画",
  "drive.type.zip": "ZIP",
  "drive.type.other": "その他",
  "drive.filter.owner.aria": "所有者でフィルター",
  "drive.filter.owner.label_all": "所有者: だれでも",
  "drive.owner.you": "あなた",
  "drive.owner.external": "外部",
  "drive.owner.any": "だれでも",
  "drive.details": "詳細",
  "drive.tree_aria_label": "マイドライブ ツリー",
  "drive.breadcrumbs_aria_label": "現在のパス",
  "drive.view.list": "リスト",
  "drive.view.grid": "グリッド",
  "drive.view.list_aria": "リスト表示",
  "drive.view.grid_aria": "グリッド表示",
  "drive.sort.by": "並べ替え",
  "drive.sort.dir": "並べ替えの方向",
  "drive.sort.key.name": "名前",
  "drive.sort.key.type": "ファイル種別",
  "drive.sort.key.owner": "所有者",
  "drive.sort.key.modified": "最終更新",
  "drive.sort.key.size": "サイズ",
  "drive.dir.asc": "昇順",
  "drive.dir.desc": "降順",
  "drive.results_showing": "表示中",
  "drive.table.aria_label": "項目一覧",
  "drive.table.name": "名前",
  "drive.table.file_type": "ファイル種別",
  "drive.table.owner": "所有者",
  "drive.table.last_modified": "最終更新",
  "drive.table.size": "サイズ",
  "drive.shared": "共有済み",
  "drive.preview": "プレビュー",
  "drive.details.name": "名前",
  "drive.details.type": "種類",
  "drive.details.location": "場所",
  "drive.details.owner": "所有者",
  "drive.details.size": "サイズ",
  "drive.details.created": "作成",
  "drive.details.last_modified": "最終更新",
  "drive.details.shared": "共有",
  "drive.yes": "はい",
  "drive.no": "いいえ",
  "drive.details.permissions": "権限",
  "drive.permissions.read_only": "読み取り専用",
  "drive.no_selection_hint": "詳細を表示するには項目を選択してください。",
  "drive.filters_aria": "Filters",
  "drive.hide_tree": "Hide tree",
  "drive.show_tree": "Show tree",
  "drive.refreshing": "Refreshing...",
  "drive.loading_files": "ファイルを読み込み中...",
  "drive.preview.loading": "Loading preview...",
  "drive.preview.not_available": "プレビューは利用できません",
  "drive.by_date": "日付順",
  "drive.status.items": "件",
  "drive.status.items_one": "件",
  "drive.status.of": "/",
  "drive.status.selected": "選択中",
  "drive.status.selected_one": "選択中",
  "drive.type.email": "メール",
  "drive.context.move_to": "移動先",
  "drive.context.no_move_targets": "利用可能なフォルダーがありません",
  "drive.move_dialog.title": "ドキュメントを移動",
  "drive.move_dialog.search": "フォルダーを検索",
  "drive.move_dialog.items_suffix": "件",
  "drive.move_dialog.moving": "Moving...",
  "drive.move_dialog.error": "The file could not be moved. Check permissions or try again.",
  "drive.move_dialog.invalid_target": "Select a valid destination folder.",
  "drive.bytes": "バイト",
  "documents.error_loading": "ドキュメントの読み込み中にエラーが発生しました",
  "documents.error_deleting": "ドキュメントの削除中にエラーが発生しました",
  "documents.selected_type": "選択したタイプ",
  "documents.selected_document": "選択したドキュメント",
  "documents.group_lastWeek": "先週",
  "documents.group_lastMonth": "先月",
  "upload.clear_completed": "完了をクリア",
  "drive.contextMenu.generateSummary": "要約を生成",
  "drive.generateSummary.modalTitle": "選択したドキュメント",
  "drive.generateSummary.modalHint": "これらのドキュメントのエグゼクティブサマリーを生成します。",
  "drive.generateSummary.goToGenerate": "生成へ移動",
  "drive.generateSummary.noDocuments": "インデックス済みのドキュメントを少なくとも1つ選択してください。",
  "documents.versions.action": "バージョン履歴",
  "documents.versions.title": "バージョン履歴",
  "documents.versions.empty": "このドキュメントにはまだバージョンがありません。",
  "documents.versions.error": "バージョン履歴を読み込めませんでした。",
  "documents.versions.active": "現行",
  "documents.versions.close": "閉じる",
};
